import { FormValidationService } from './../../../../../services/form-validation.service';
import { DataService } from './../../../../../services/data.service';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';


import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';



@Component({
  selector: 'app-student-contact-address',
  templateUrl: './student-contact-address.component.html',
  styleUrls: ['./student-contact-address.component.scss']
})
export class StudentContactAddressComponent implements OnChanges, OnDestroy {
  @Input() userAddress: any;

  @Output() addressUpdate: EventEmitter<any> = new EventEmitter<any>();

  stateData = this.dataService.getEntity('State').item || [];

  addressForm: FormGroup;
  addressPattern = /^[a-zA-Z0-9_,.#' -`’]+$/;
  backendUpdate = false;

  private destroyed$ = new Subject();

  constructor(
    private dataService: DataService,
    private formBuilder: FormBuilder,
    private _formValidationService: FormValidationService
  ) {
    this.buildForm();
    this._formValidationService.touchForms
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
      this.addressForm.markAsTouched();
      (<any>Object).values(this.addressForm.controls).forEach((control: FormControl) => {
        control.markAsTouched();
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['userAddress'] !== undefined && changes['userAddress'].currentValue !== undefined) {
      this.backendUpdate = true;
      this.hydrateForm(changes['userAddress'].currentValue);
      this.backendUpdate = false;
    }
  }

  ngOnDestroy() {
    this.destroyed$.next();
  }

  buildForm() {
    this.addressForm = this.formBuilder.group({
      line1: ['', Validators.compose([Validators.required, Validators.pattern(this.addressPattern)])],
      line2: ['', Validators.compose([Validators.pattern(this.addressPattern)])],
      city: ['', Validators.compose([Validators.required])],
      stateClassId: ['', Validators.required],
      zipCode: ['', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5), Validators.pattern(/^[0-9]/)])]
    });

    this.addressForm.valueChanges
      .filter(() => this.addressForm.valid && !this.backendUpdate)
      .pipe(debounceTime(10), takeUntil(this.destroyed$))
      .subscribe(newAddress => this.updateAddress(newAddress));

    this._formValidationService.registerForm('addressForm', this.addressForm);
  }

  hydrateForm(newData) {
    const values = {
      line1: newData ? (newData.address1 || newData.line1) : '',
      line2: newData ? (newData.address2 || newData.line2) : '',
      city: newData ? newData.city : '',
      stateClassId: newData ? (newData.stateValue || newData.stateClassId) : '0',
      zipCode: (newData && +newData.zipCode !== 0) ? newData.zipCode : ''
    };

    this.addressForm.patchValue(values);
  }

  updateAddress(values) {
    this.addressUpdate.emit(values);
  }

}
